<template>
	<div class="userbg">
		<infoview :tabs="2"></infoview>
		<div class="userinfobg">

			<div class="userinfotop">
				<p>{{$t('OrderInfo.OrderInfo_1')}}</p>
				<span>{{$t('infoview.infoview_3')}}</span>
			</div>
			<div class="orderkb" v-if="orderlist ==''">
				{{$t('OrderInfo.OrderInfo_7')}}
			</div>
			<div class="order" v-else v-for="(item,index) in orderlist" :key="index"
				@click="OrderInfoDetail(item.TKAMSTID)">
				<el-row :gutter="20" class="orderitem">
					<el-col :span="8">
						<div class="orderbox">{{$t('OrderInfo.OrderInfo_2')}}</div>
					</el-col>
					<el-col :span="16">
						<div class="ordertext">{{item.TKAMSTID}}</div>
					</el-col>
				</el-row>
				<el-row :gutter="20" class="orderitem">
					<el-col :span="8">
						<div class="orderbox">{{$t('OrderInfo.OrderInfo_3')}}</div>
					</el-col>
					<el-col :span="16">
						<div class="ordertext ordername">{{item.TKANAME1}}</div>
					</el-col>
				</el-row>
				<el-row :gutter="20" class="orderitem">
					<el-col :span="8">
						<div class="orderbox">{{$t('OrderInfo.OrderInfo_4')}}</div>
					</el-col>
					<el-col :span="16">
						<div class="ordertext">{{item.TKASTAHO}}</div>
					</el-col>
				</el-row>
				<el-row :gutter="20" class="orderitem">
					<el-col :span="8">
						<div class="orderbox">{{$t('OrderInfo.OrderInfo_5')}}</div>
					</el-col>
					<el-col :span="16">
						<div class="ordertext">{{item.INIHOURS}}</div>
					</el-col>
				</el-row>
				<el-row :gutter="20" class="orderitem">
					<el-col :span="8">
						<div class="orderbox">{{$t('OrderInfo.OrderInfo_6')}}</div>
					</el-col>
					<el-col :span="16">
						<div class="ordertext">{{item.INIPAYNM}}</div>
					</el-col>
				</el-row>
			</div>
		</div>

	</div>
</template>

<script>
	import infoview from '../components/home/info/infoview.vue'

	export default {
		name: 'OrderInfo',
		components: {
			infoview
		},
		data() {
			return {
				orderlist: [{
					ordernum: '12345678910',
					ordertype: 'NISSAN SKYLINE GT-R BNR32',
					ordertime: '2022-10-9 9:00',
					orderdataleng: '3h',
					orderway: 'クレジット'
				}],
				lang: 0
			};
		},
		watch: {},
		computed: {},
		methods: {
			getOrderInfo() {
				console.log(this.$i18n.locale)
				if (this.$i18n.locale == 'ja') {
					this.lang = 0
				}
				if (this.$i18n.locale == 'zh') {
					this.lang = 1
				}
				if (this.$i18n.locale == 'en') {
					this.lang = 2
				}
				this.$api.post(this.$config.Get_OrderInfo, {
						'sMSTID': sessionStorage.getItem('log_mstid'),
						'sLNGCT': this.lang
					},
					// 请求成功
					success => {
						this.orderlist = success.KKDT
						console.log(this.orderlist)
					},
					// 请求失败
					error => {
						console.log(error)
					}
				)
			},
			OrderInfoDetail(TID) {
				console.log(TID)
				// this.$router.push('/OrderInfoDetail')
				this.$router.push({
					path: 'OrderInfoDetail',
					query: {
						sMSTID: TID,
					} // 要传递的参数
				})

			}

		},
		created() {

		},
		mounted() {
			this.getOrderInfo()
		}
	}
</script>

<style scoped>
	@media only screen and (min-width:800px) {
		.userbg {
			width: 80%;
			margin: 0 auto;
			padding-top: 60px;
			display: flex;
			flex-direction: row;
		}

		.userinfotop {

			margin-bottom: 45px;
		}

		.userinfotop>p {
			font-size: 50px;
			font-family: Roboto-Bold, Roboto;
		}
	}

	@media only screen and (max-width:800px) {
		.userbg {
			width: 90%;
			margin: 0 auto;
			padding-top: 10px;
			display: block;
		}

		.userinfotop {

			margin-bottom: 25px;
		}

		.userinfotop>p {
			font-size: 30px;
			font-family: Roboto-Bold, Roboto;
			margin-top: 20px;
		}

	}

	.userinfobg {
		width: 100%;
	}



	.userinfotop>span {
		font-size: 12px;
		font-family: Noto Sans CJK JP-Bold, Noto Sans CJK JP;
	}

	.order {
		border: 1px solid #ddd;
		padding: 0 26px;
		box-sizing: border-box;
		padding-bottom: 28px;
		margin-bottom: 30px;
	}

	.orderitem {
		border-bottom: 1px solid #ddd;
		line-height: 40px;
		padding: 10px 0;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.orderbox {
		text-align: center;
		font-size: 14px;
		font-family: Noto Sans CJK JP-Bold, Noto Sans CJK JP;
		font-weight: bold;
	}

	.ordertext {
		font-size: 14px;
		font-family: Roboto-Medium, Roboto;

	}

	.orderkb {
		font-size: 32px;
		text-align: center;
	}
</style>
